// extracted by mini-css-extract-plugin
module.exports = {"row":"Notification_row__2OYUF","col":"Notification_col__2v_RQ"};